








































































































































































































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import EditorWithFile from "@/components/EditorWithFile.vue";
import TestQuestionsList from "@/components/tests/TestQuestionsList.vue";
import api from "@/getinfo-api";
import { TestQuestion as ITestQuestion } from "@/api/models/test-question";
import { isRoot, getCurrentUserId } from "@/plugins/roles";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { AxiosError } from "axios";
import { TestQuestionCreate as ITestQuestionCreate } from "@/api/models/test-question-create";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { Test as ITest } from "@/api/models/test";
import { TestCreate as ITestCreate } from "@/api/models/test-create";
import { TestEdit as ITestEdit } from "@/api/models/test-edit";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { Company as ICompany } from "@/api/models/company";
import Modal from "@/components/form/Modal.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { LearningMaterialLocales } from "@/plugins/custom-interface";
import CSingleSelect from "@/components/form/CSingleSelect.vue";

@Component({
  components: {
    CSingleSelect,
    CBlock,
    CField,
    CustomButton,
    Modal,
    EditorWithFile,
    TestQuestionsList
  }
})
export default class TestForm extends Vue {
  @Ref("questList") questList!: TestQuestionsList;
  @Prop() test!: ITest;
  @Prop() testQuestions?: ITestQuestion[];
  @Prop() questionLoading?: boolean;
  error!: any;
  questionsList!: Array<ITestQuestionCreate>;
  description: string = "";
  title!: string;
  root: boolean = false;
  employees!: IEmployeesList2;
  selectedCompany!: string;
  attemptsCount: number = 0;
  attemptsCountPerDay: number = 0;
  questionsCountToCompletion: number = 1;
  questionsCount: number = 0;
  timeLimit: number = 0;
  enabled: boolean = true;
  showAddQuestionBlock: boolean = true;
  ownerId!: string;
  filteredCompanyName!: string;
  isSavingProcess: boolean = false;
  intermediateTest: boolean = false;
  testAnswerComment: boolean = false;
  randomize: boolean = false;
  askAllQuestionsInPracticeTesting: boolean = false;
  doNotLimitTheTimeOfPracticeTesting: boolean = false;
  showAnswersImmediatelyInPracticeTesting: boolean = false;
  locale: string = "";

  data() {
    return {
      title: undefined,
      questionsList: undefined,
      ownerId: undefined,
      coursesList: undefined,
      selectedCompany: undefined,
      selectedCourse: undefined,
      lecturesList: undefined,
      selectedLecture: undefined,
      employees: undefined,
      filteredCompanyName: undefined,
      error: undefined
    };
  }

  @Watch("companyInStore")
  updateCompany() {
    if (!this.test) {
      this.getEmployeeByCompany();
    }
  }

  get locales() {
    return LearningMaterialLocales();
  }

  get companyInStore() {
    return this.$store.getters.selectedCompany.id;
  }

  getEmployeeByCompany() {
    let params: EmployeeListParams = {
      id: this.companyInStore,
      roles: ["content_manager"],
      limit: 200
    };

    employee(params)
      .then((res: { data: IEmployeesList2 }) => {
        this.employees = res.data;
        if (this.employees.employees.length) {
          if (this.root || !this.roles.includes("content_manager")) {
            this.ownerId = this.employees.employees[0].user.id;
          } else {
            this.ownerId = this.userId;
          }
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get roles() {
    return this.$store.getters.roles;
  }

  get userId() {
    return getCurrentUserId();
  }

  async createTest() {
    if (!this.test) {
      this.questionsList = this.questList.questionList;
      if (this.questionsList.length >= this.questionsCount) {
        let testCreateData: ITestCreate = {
          companyId: this.companyInStore,
          questions: this.questionsList,
          title: this.title,
          ownerId: this.ownerId,
          questionsCount:
            this.questionsCount === 0
              ? this.questionsList.length
              : this.questionsCount,
          attemptsCount: this.attemptsCount,
          attemptsCountPerDay: this.attemptsCountPerDay,
          questionsCountToCompletion: this.questionsCountToCompletion,
          timeLimit: this.timeLimit,
          enabled: this.enabled,
          intermediateTest: this.intermediateTest,
          testAnswerComment: this.testAnswerComment,
          randomize: this.randomize,
          showAllQuestions: this.askAllQuestionsInPracticeTesting,
          considerTime: this.doNotLimitTheTimeOfPracticeTesting,
          showAnswer: this.showAnswersImmediatelyInPracticeTesting,
          locale: this.locale ?? ""
        };
        this.isSavingProcess = true;
        api.TestApi.create(testCreateData)
          .then((res: { data: ITest }) => {
            if (res.data) {
              this.$bvToast.toast(`${res.data.title}`, {
                variant: "success",
                title: this.$tc(this.$translate.Successful)
              });
              this.$router.push({
                name: "testList"
              });
            }
          })

          .catch(
            (error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
              if (error.response) {
                this.error = error.response.data;
                this.$bvToast.toast(`${error.response.data.message}`, {
                  variant: "danger",
                  title: this.$tc(this.$translate.Error)
                });
              }
            }
          )
          .finally(() => {
            this.isSavingProcess = false;
          });
      } else {
        this.$bvToast.toast(
          this.$tc(
            this.$translate
              .TheNumberOfCreatedTestQuestionsCannotBeLessThanTheActualNumberOfQuestionsInTheTest
          ),
          {
            variant: "danger",
            title: this.$tc(this.$translate.Error)
          }
        );
      }
    } else {
      this.isSavingProcess = true;
      let all = this.questList.questionList;
      if (all.length >= this.questionsCount) {
        let arrayQuestionCreate: Array<ITestQuestionCreate> = [];

        if (all.length > 0) {
          // Удаляем все вопросы id которых есть в массиве для удаления
          if (this.questList.questionsIdsToDeleted) {
            await Promise.allSettled(
              this.questList.questionsIdsToDeleted?.map(async element => {
                await api.TestApi.deleteQuestion(this.test.id, element);
              })
            );
          }

          // проходим по каждому вопросу и крепим его к тесту
          let arrayToCreate: Array<ITestQuestionCreate> = this.questList
            .questionsForCreate;

          arrayToCreate.forEach((element: any) => {
            let answers: Array<any> = [];
            element.answers.forEach((answer: any) => {
              let answerParams: any = {
                body: answer.body,
                value: answer.value,
                comment: answer.comment
              };
              answers.push(answerParams);
            });
            let question: ITestQuestionCreate = {
              body: element.body,
              answers: answers,
              sort: element.sort ?? 0
            };
            arrayQuestionCreate.push(question);
          });

          await Promise.allSettled(
            arrayQuestionCreate.map(async element => {
              await api.TestApi.addQuestion(this.test.id, element);
            })
          );

          this.isSavingProcess = true;
          let testEditParams: ITestEdit = {
            title: this.title,
            ownerId: this.ownerId,
            questionsCount:
              this.questionsCount === 0 ? all.length : this.questionsCount,
            attemptsCount: this.attemptsCount,
            attemptsCountPerDay: this.attemptsCountPerDay,
            questionsCountToCompletion: this.questionsCountToCompletion,
            timeLimit: this.timeLimit,
            enabled: this.enabled,
            intermediateTest: this.intermediateTest,
            testAnswerComment: this.testAnswerComment,
            randomize: this.randomize,
            showAllQuestions: this.askAllQuestionsInPracticeTesting,
            considerTime: this.doNotLimitTheTimeOfPracticeTesting,
            showAnswer: this.showAnswersImmediatelyInPracticeTesting,
            locale: this.locale ?? ""
          };
          api.TestApi.edit(this.test.id, testEditParams)
            .then(() => {
              this.$store.dispatch("successToast", {
                message: this.$tc(
                  this.$translate.ChangesHaveBeenSuccessfullySaved
                )
              });
            })
            .catch(
              (
                error: AxiosError<IErrorResponse | IValidationErrorResponse>
              ) => {
                if (error.response) {
                  this.$bvToast.toast(`${error.response.data.message}`, {
                    variant: "danger",
                    title: this.$tc(this.$translate.Error)
                  });
                }
              }
            )
            .finally(() => {
              this.isSavingProcess = false;
            });
        } else {
          this.isSavingProcess = false;
          this.$bvToast.toast(this.$tc(this.$translate.AddQuestionsToTheTest), {
            variant: "danger",
            title: this.$tc(this.$translate.Error)
          });
        }
      } else {
        this.isSavingProcess = false;
        this.$bvToast.toast(
          this.$tc(
            this.$translate
              .TheNumberOfCreatedTestQuestionsCannotBeLessThanTheActualNumberOfQuestionsInTheTest
          ),
          {
            variant: "danger",
            title: this.$tc(this.$translate.Error)
          }
        );
      }
    }
  }

  getQuestions(a: Array<ITestQuestionCreate>) {
    this.questionsList = a;
  }

  checkMinCount(value: number) {
    return value < 1 ? 1 : value;
  }

  deleteTest() {
    if (this.test.id) {
      this.isSavingProcess = true;
      api.TestApi._delete(this.test.id)
        .then(() => {
          this.$router.push({ name: "testList" });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.isSavingProcess = false;
        });
    }
  }

  mounted() {
    this.root = isRoot();

    if (this.test) {
      this.title = this.test.title;
      this.selectedCompany = this.test.companyId;
      this.questionsCount = this.test.questionsCount;
      this.questionsCountToCompletion = this.test.questionsCountToCompletion;
      this.attemptsCount = this.test.attemptsCount;
      this.attemptsCountPerDay = this.test.attemptsCountPerDay;
      this.timeLimit = this.test.timeLimit;
      this.enabled = this.test.enabled;
      this.intermediateTest = this.test.intermediateTest;
      this.testAnswerComment = this.test.testAnswerComment;
      this.randomize = this.test.randomize;
      this.askAllQuestionsInPracticeTesting = this.test.showAllQuestions;
      this.doNotLimitTheTimeOfPracticeTesting = this.test.considerTime;
      this.showAnswersImmediatelyInPracticeTesting = this.test.showAnswer;
      this.locale = this.test.locale ?? "";
      api.CompanyApi.get(this.test.companyId)
        .then((res: { data: ICompany }) => {
          this.filteredCompanyName = res.data.title;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });

      let params: EmployeeListParams = {
        id: this.test.companyId,
        roles: ["content_manager"],
        limit: 200
      };
      employee(params)
        .then((res: { data: IEmployeesList2 }) => {
          this.employees = res.data;
          if (this.employees.employees.length) {
            this.ownerId = this.test.ownerId;
          }
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    } else {
      if (this.companyInStore) {
        this.getEmployeeByCompany();
      }
    }
  }
}
